import React from 'react'
import Grid from '@material-ui/core/Grid'
import M_FieldSelect from 'components/1_Atoms/2_Molecules/M_FieldSelect'
import M_ButtonSubmit from 'components/1_Atoms/2_Molecules/M_ButtonSubmit'
import { baseInfo } from 'types/SearchTypes'
import { useButtons, useJigyoCd, useMail, useTenCd, useTokuiCd } from 'hooks/useUserTorokuForm'
import { useMediaQueryContext } from 'MediaQueryProvider'
import M_FieldCheckRight from 'components/1_Atoms/2_Molecules/M_FieldCheckRight'
import Typography from '@material-ui/core/Typography'

type Props = {
  info: baseInfo
}

const O_SearchBoxUser = ({ info }: Props) => {
  const [JIGYO_CD, changeJigyoCd] = useJigyoCd()
  const [MAIL, changeMail, inclideKari, changeInclideKari] = useMail()
  const [TOKUI_CD, changeTokuiCd] = useTokuiCd()
  const [TEN_CD, changeTenCd] = useTenCd()
  const [clickReset] = useButtons()
  const { isMobileSite } = useMediaQueryContext()
  const xs = isMobileSite ? 12 : 4
  const xsLarge1 = isMobileSite ? 12 : 5
  const xsLarge2 = isMobileSite ? 12 : 3

  return (
    <div>
      <Grid container spacing={1}>
        {/* //////////////////// 1 行目 //////////////////// */}
        <Grid item xs={xs}>
          {/* ==== 事業所 ==== */}
          <M_FieldSelect label="事業所" valueCode={JIGYO_CD} valueSet={info.jigyoList} event={changeJigyoCd} />
        </Grid>
        <Grid item xs={xsLarge1}>
          {/* ==== ユーザー ==== */}
          <M_FieldSelect label="ユーザー" valueCode={MAIL} valueSet={info.userList!} event={changeMail} />
        </Grid>
        <Grid item xs={xsLarge2}>
          <M_FieldCheckRight label="仮登録ユーザー検索" isChecked={inclideKari} event={changeInclideKari} />
        </Grid>

        {/* //////////////////// 2 行目 //////////////////// */}
        <Grid item xs={xs}>
          {/* ==== 得意先 ==== */}
          <M_FieldSelect label="得意先" valueCode={TOKUI_CD} valueSet={info.tokuiList} event={changeTokuiCd} disabled={TEN_CD !== '-1'} />
        </Grid>
        <Grid item xs={xs}>
          {/* ==== 店舗 ==== */}
          <M_FieldSelect label="店舗" valueCode={TEN_CD} valueSet={info.tenList} event={changeTenCd} disabled={TOKUI_CD === '-1'} />
        </Grid>
        <Grid item xs={xs}>
          {/* -------- [ 検索条件リセットボタン ] -------- */}
          <Grid container justifyContent="flex-end">
            <M_ButtonSubmit label="検索条件リセット" event={clickReset} />
          </Grid>
        </Grid>
        {/* //////////////////// 3 行目 //////////////////// */}
        <Grid item xs={xs}>
          <Typography variant="subtitle2" display="block" color="error">
            {'※背景色がピンク色のユーザーは仮登録状態です。'}
          </Typography>
        </Grid>
      </Grid>
    </div>
  )
}
export default React.memo(O_SearchBoxUser)
